import React from 'react';
import PropTypes from 'prop-types';

import SimpleHeader from '../../main/headers/simpleHeader';
import { t } from '../../../modules/infra/i18n';

const NoOfferView = ({ onLearnMoreClicked }) => (
  <div>
    <SimpleHeader heading={t('loans:no_offer.header')} />
    <div className="c-inner-wrapper c-loans-no-offer">
      <div className="u-max-width-620">
        <div className="c-heading c-heading--dark u-fontsize-large u-type--semibold">{t('loans:no_offer.title')}</div>
        <div className="c-loans-no-offer--text">{t('loans:no_offer.description')}</div>
        <button
          className="c-btn c-btn--medium c-loans-no-offer--button"
          type="button"
          onClick={onLearnMoreClicked}
          data-automation-id="loans-no-offer-details-button"
        >
          {t('loans:no_offer.learn_more_button')}
        </button>
        <div className="c-loans-no-offer--disclaimer">{t('loans:no_offer.disclaimer')}</div>
      </div>
    </div>
    <div className="u-fontsize-extrasmall u-m">{t('loans:no_offer.footer_disclaimer')}</div>
  </div>
);

NoOfferView.propTypes = {
  onLearnMoreClicked: PropTypes.func.isRequired,
};

export default NoOfferView;
